import clonedeep from 'lodash.clonedeep';
import * as FilterTypeConstants from '../constants/filter-types';

/**
 * Return a new array of active filters with empty values based on filterOptions object from api data
 *
 * @param {Array} filters - The filters to update
 * @returns {Array} Returns - A filtered set of data
 *
 * Example usage:
 *
 * this.setState({
 *      activeFilters: initActiveFilters(this.props.data.filterOptions);
 *
 * });
 */
export function initActiveFilters(filters) {
    // Early return if filters is not supplied
    if (!filters || !filters.length) { return []; }

    // reset values of the default active filters to empty array
    const defaultActiveFilters = clonedeep(filters);

    defaultActiveFilters.map(filter => {
        filter.values = [];
        return filter;
    });

    return defaultActiveFilters;
}

/**
 * Returns the passed in active filters with the targeted filter's value updated
 *
 * @param {Array} activeFilters - The active filters, this is an array of objects, each object must at least have the 'code' and 'values' properties
 * @param {string} targetCode - The targeted filter code
 * @param {string} value - The value to be added / removed from the targeted filter
 * @param {bool} forceClear - Force the active filters' value to be cleared (for all filters other than multi checkbox)
 * @returns {Array} Returns - updated active filters
 */
export function manageActiveFilters(activeFilters, targetCode, value, forceClear) {
    if (!activeFilters || !targetCode) { return activeFilters; }
    // Clone and loop through the active filters to check against the targeted filter targetCode and
    // to add / remove the specified value from the filter's value list
    const clonedActiveFilters = clonedeep(activeFilters);

    clonedActiveFilters.forEach(item => {
        // Skip item if it does not match our target code
        if (!item || item.code !== targetCode) { return; }
        // If filter is checkbox, we toggle the values on / off
        if (item.type === FilterTypeConstants.FILTER_TYPE_MULTI_CHECKBOX
            || item.type === FilterTypeConstants.FILTER_TYPE_SINGLE_CHECKBOX
            || item.type === FilterTypeConstants.FILTER_TYPE_TAGS) {
            let valuesArray = [];
            if (value.constructor !== Array) {
                valuesArray = value.split();
            } else {
                valuesArray = value;
            }
            valuesArray.forEach(valueInd => {
                if (item.values.includes(valueInd)) {
                    // filter out all values from item's values array
                    // that are NOT equal to the deselected value
                    item.values = item.values.filter(val => val !== valueInd);
                } else {
                    // add value to values array of this specific active filter
                    item.values = [...item.values, valueInd];
                }
            });
        } else if (!value || forceClear) {
            // All other types of filter, we simply wipe and update the active filter value
            item.values = [];
        } else {
            item.values = [value];
        }
    });

    return clonedActiveFilters;
}

/**
 * Return a new array of active filters with empty values based on filterOptions object from api data
 *
 * @param {Array} activeFilters - The active filters to check
 * @param {String} groupCode - The group code to remove
 * @returns {Array} Returns - the active filters that has values
 */
export function removeActiveFilterGroup(activeFilters, groupCode) {
    // Return early if we dont have enough info
    if (!activeFilters || !groupCode) { return activeFilters; }


    // Copy and loop through the active filters to check against the targeted filter groupCode and remove the matching item's values
    const clonedActiveFilters = clonedeep(activeFilters);

    clonedActiveFilters.forEach(item => {
        // Skip item if it does not match our target code
        if (!item || item.code !== groupCode) { return; }

        // Remove the values from the matching group
        item.values = [];
    });

    return clonedActiveFilters;
}

/**
 * Return a new array of active filters with empty values based on filterOptions object from api data
 *
 * @param {Array} filters - The active filters to check
 * @returns {Array} Returns - the active filters that has values
 */
export function getActiveFiltersWithValues(filters) {
    // Early return if filters is not supplied
    if (!filters || !filters.length) { return []; }

    // Only return the filter items with values
    // return filters.filter(item => item.values && item.values.length);
    return filters.filter(item => {
        let returnItem;
        if (item.values && item.values.length) {
            returnItem = item;
        }
        return returnItem;
    });
}


// Find the active filter values of the specific filter
export function getActiveValues(filter, activeFilters) {
    const found = activeFilters.find(item => item.code === filter.code);

    return found ? found.values : [];
}
